/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const CredentialImportRequest: core.serialization.Schema<
    serializers.CredentialImportRequest.Raw,
    Omit<Truvity.CredentialImportRequest, 'blobId' | 'draftId' | 'idempotencyKey'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
});

export declare namespace CredentialImportRequest {
    export interface Raw {
        annotations?: Record<string, string> | null;
        labels?: Record<string, string> | null;
    }
}
